import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { ClientSelect } from '@/lib/ClientSelect';
import { PIECE_TYPES } from '@/utils/constants';

export function TaskBasicTab({ formData, onChange, canEdit }) {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 gap-6">
        <div>
          <Label htmlFor="client_name">Client Name *</Label>
          {canEdit ? (
            <ClientSelect value={formData.client_name} onChange={v => onChange('client_name', v)} placeholder="Select client..." className="w-full mt-2" />
          ) : (
            <Input id="client_name" value={formData.client_name} disabled className="mt-2" />
          )}
        </div>
        <div>
          <Label htmlFor="ks_design_no">KS Design No</Label>
          <Input id="ks_design_no" value={formData.ks_design_no || ''} disabled className="mt-2 bg-muted cursor-not-allowed font-mono font-semibold" />
        </div>
        <div>
          <Label htmlFor="party_cad_no">Party CAD No</Label>
          <Input id="party_cad_no" value={formData.party_cad_no} onChange={e => onChange('party_cad_no', e.target.value)} disabled={!canEdit} className="mt-2" />
        </div>
        <div>
          <Label htmlFor="style_no">Style No</Label>
          <Input id="style_no" value={formData.style_no} onChange={e => onChange('style_no', e.target.value)} disabled={!canEdit} className="mt-2" />
        </div>
        <div>
          <Label htmlFor="product_name">Product Name</Label>
          <Input id="product_name" value={formData.product_name} onChange={e => onChange('product_name', e.target.value)} disabled={!canEdit} className="mt-2" />
        </div>
      </div>
      <div className="border-t border-slate-200 pt-6">
        <h3 className="text-lg font-semibold mb-4">Product Classification</h3>
        <div className="grid grid-cols-2 gap-6">
          <div>
            <Label htmlFor="piece_type">Piece Type *</Label>
            <select id="piece_type" value={formData.piece_type} onChange={e => onChange('piece_type', e.target.value)} required disabled={!canEdit}
              className="mt-2 w-full h-10 px-3 border border-slate-200 rounded-md bg-white focus:outline-none focus:ring-2 focus:ring-slate-900/10">
              {PIECE_TYPES.map(type => <option key={type.value} value={type.value}>{type.label}</option>)}
            </select>
          </div>
          <div>
            <Label htmlFor="size">Size</Label>
            <Input id="size" value={formData.size} onChange={e => onChange('size', e.target.value)} disabled={!canEdit} className="mt-2" />
          </div>
        </div>
      </div>
    </div>
  );
}
